
import React, { useEffect, useRef } from "react";
import { Container, Placeholder } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import uniqid from 'uniqid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import ScrollButtons from "./ScrollButtons";
import CategoryTitle from "./CategoryTitle";
import CategoryLinkIconLeft from "./CategoryLinkIconLeft";

import slots from '../data/icons/slots.svg';
import table from '../data/icons/filter/table.svg';
import lottery from '../data/icons/filter/jackpot.svg';
import virtual from '../data/icons/betting.svg';
import scratch from '../data/icons/filter/popular.svg';
import bingo from '../data/icons/fruits.svg';
import instant from '../data/icons/crash.svg';
import dice from '../data/icons/filter/lobby.svg';
import unique from '../data/icons/filter/new.svg';
import wheelOfFortune from '../data/icons/gold.svg';
import cards from '../data/icons/cards.svg';
import keno from '../data/icons/keno.svg';


// import './allGamesRow.scss';


export default function AllGamesRow({ categoryURL }) {
    const country = useSelector((state) => state.globalContent.data.country)
    const categories = useSelector((state) => state.gameCategories.list);
    const category = categories ? (categories[`${categoryURL}-${country.ISOcode}`] || categories[categoryURL]) : null;
    const locale = useSelector((state) => state.globalContent.data.locale);

    const container = useRef(null);
    const placeholder = new Array(20).fill(null);

    return (
        <Container fluid="lg" className="game-row-container section-margin">

            {/* Title */}
            {/* <div className="all-games-row-squares-title-wrapper">
                <CategoryTitle title="Pick your game type" className="mt-0" />
                <Link to={`/${locale}/games/all-games`} className="mt-0 mb-3 all-games-row-squares-title-link">5,027 games</Link>
            </div> */}
            <CategoryTitle title="Pick your game type" className="mt-0 mb-3" />

            {/* Row */}
            <div className="position-relative">
                <div className="all-games-row-squares-wrapper" ref={container}>

                    {/* Games */}
                    {
                        !category ? placeholder.map((tag) => <GameTypeTile tag={tag} key={uniqid()} />) :
                            category.tags.map(item => {
                                return <GameTypeTile tag={item.tag} key={uniqid()} />
                            })
                    }
                </div>

                {/* Scroll */}
                <ScrollButtons container={container} />
            </div>
        </Container>
    );
}

function GameTypeTile({ tag }) {
    const locale = useSelector((state) => state.globalContent.data.locale);
    const images = {
        'Slots': slots,
        'Table': table,
        'Lottery': lottery,
        'Virtual sports': virtual,
        'Scratch': scratch,
        'Bingo': bingo,
        'Instant crash': instant,
        'Dice': dice,
        'Unique': unique,
        'Wheel of fortune': wheelOfFortune,
        'Cards' : cards,
        'Keno' : keno
    }

    useEffect(() => { })

    if (!tag) {
        return (
            <Placeholder as="div" animation="glow">
                <Placeholder xs={12} className="all-games-row-square-placeholder" />
            </Placeholder>
        )
    }

    return (
        // <Link to={`/${locale}/games/all-games/${encodeURI(tag)}`} className="all-games-tile-container">
        //     <div className="all-games-tile-image-wrapper">
        //         <img className="all-games-tile-image" src={images[tag]} alt="" />
        //     </div>
        //     <div className="all-games-tile-text-wrapper">
        //         <h3 className="h5 all-games-tile-text">{tag}</h3>
        //         <FontAwesomeIcon icon={faChevronRight} />
        //     </div>
        // </Link>
        <CategoryLinkIconLeft to={`/${locale}/games/all-games/${encodeURI(tag)}`} title={tag} src={images[tag]} alt='' />
    )
}